<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-row>
      <v-col cols="12" md="12">
        <v-card
          class="border-radius box-shadow">
          <v-card-text class="py-0">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              :color="style.primary"
              slider-size="4">
              <v-tabs-slider :color="style.primary"></v-tabs-slider>
              <v-tab
                v-for="(item, index) in menu"
                :key="index"
                class="text-capitalize"
                v-if="item.is_access == true || item.role == '*'"

              >
                <span class="body-2" :class="tab === index ? 'font-weight-bold color-default' : 'text-third'">
                  {{ item.label }}
                </span>
              </v-tab>
            </v-tabs>
            <v-divider/>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="(item, index) in menu"
                :key="index"
                v-if="item.is_access == true || item.role == '*'"
              >
                <router-view :model="tab"/>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tab: this.$store.state.user === 'superuser' ? 0 : 1,
        menu: [
          /*
          administrator
          developer
          finance
          marketing
          partner
          superuser
          supervisor
          teknik
          */
          {
            label: 'Pengguna',
            value: '/setting/member',
            role: ['superuser', 'supervisor', 'administrator']
          },
          {
            label: 'Fasilitas',
            value: '/setting/facility',
            role: ['superuser', 'administrator']
          },
          {
            label: 'Bank',
            value: '/setting/bank',
            role: ['superuser', 'administrator']
          },
          {
            label: 'Dokumen',
            value: '/setting/document',
            role: ['superuser', 'administrator']
          },
          {
            label: 'Config DP',
            value: '/setting/dp',
            role: ['superuser', 'administrator']
          },
          {
            label: 'Config SPKPR',
            value: '/setting/spkpr',
            role: ['superuser', 'administrator']
          },
          {
            label: 'Config TTD',
            value: '/setting/signature',
            role: ['superuser', 'administrator']
          }
        ],
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
    },
    watch: {
      'tab': function(val) {
        this.$router.push({ path: `${this.menu[val].value}` })
      }
    },
    mounted () {
      this.tab = 
        this.$route.path === '/setting/member' ? 0 : 
        this.$route.path === '/setting/facility' ? 1 : 
        this.$route.path === '/setting/bank' ? 2 : 
        this.$route.path === '/setting/document' ? 3 : 
        this.$route.path === '/setting/dp' ? 4 :
        this.$route.path === '/setting/spkpr' ? 5 : 6
      
      var menu_temp = []

      this.menu.forEach(item => {
        item.is_access = false;

        this.user.user_company_roles_name.forEach(obj => {
          // console.log(obj)
          // console.log(item.role)
          // console.log(item.role.includes(obj))

          if (item.role.includes(obj)) {
            item.is_access = true;
          }          
        })

        menu_temp.push(item)
      })

      this.menu = menu_temp
    },
    methods: {
      
    }
  }
</script>